// extracted by mini-css-extract-plugin
module.exports = {"ServiceEditDialog":"ServiceEditDialog_ServiceEditDialog__1XsBb"};